import { render, staticRenderFns } from "./OTSCredentialsConnection.vue?vue&type=template&id=5620b04a&scoped=true"
import script from "./OTSCredentialsConnection.vue?vue&type=script&lang=js"
export * from "./OTSCredentialsConnection.vue?vue&type=script&lang=js"
import style0 from "./OTSCredentialsConnection.vue?vue&type=style&index=0&id=5620b04a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620b04a",
  null
  
)

export default component.exports